<div class="legend" aria-hidden="true">
  <span><i class="dot opens"></i><span i18n="@@activityOpens">Kachel-Aufrufe</span></span>
  <span><i class="dot visits"></i><span i18n="@@activityVisits">Portalbesuche</span></span>
</div>
<div class="chart" aria-hidden="true">
  <div class="chart-grid">
    <span>{{ maxDaily | number }}</span><span>{{ maxDaily / 2 | number:'1.0-1' }}</span><span>0</span>
  </div>
  <div class="daily-chart" [class.dense]="days.length > 60">
    @for (day of days; track day.date; let i = $index) {
      <div class="day-column" [class.edge-start]="i < days.length / 5" [class.edge-end]="i > days.length * 4 / 5">
        <div class="stack" [style.height.%]="(day.opens + day.visits) / maxDaily * 100">
          <div class="bar visits" [style.flex-grow]="day.visits"></div>
          <div class="bar opens" [style.flex-grow]="day.opens"></div>
        </div>
        <div class="tip">
          <strong>{{ day.date | date:'EE, dd.MM.yyyy':'UTC' }}</strong>
          <span><i class="dot opens"></i>{{ day.opens | number }} <span i18n="@@activityOpens">Kachel-Aufrufe</span></span>
          <span><i class="dot visits"></i>{{ day.visits | number }} <span i18n="@@activityVisits">Portalbesuche</span></span>
        </div>
      </div>
    }
  </div>
</div>
<div class="chart-axis">
  @for (tick of axisTicks; track tick) {
    <span [style.left.%]="days.length > 1 ? tick / (days.length - 1) * 100 : 50">{{ days[tick].date | date:'dd.MM.':'UTC' }}</span>
  }
</div>
<details>
  <summary i18n="@@activityDailyDetails">Tageswerte anzeigen</summary>
  <div class="daily-details"><table class="table table-sm">
    <thead><tr><th i18n="@@activityDate">Datum (UTC)</th><th class="text-end" i18n="@@activityOpens">Kachel-Aufrufe</th><th class="text-end" i18n="@@activityVisits">Portalbesuche</th></tr></thead>
    <tbody>@for (day of days; track day.date) { <tr><td>{{ day.date | date:'EE, dd.MM.yyyy':'UTC' }}</td><td class="text-end">{{ day.opens | number }}</td><td class="text-end">{{ day.visits | number }}</td></tr> }</tbody>
  </table></div>
</details>
